<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="content__body">
      <ng-container *ngIf="isSuccess; then success; else error"></ng-container>
    </div>
  </mat-card-content>
  <ng-container *ngIf="isSuccess; then buttonsSuccess; else buttonsError"></ng-container>
</mat-card>

<ng-template #success>
  <img class="body__icon" src="assets/img/check_circle.svg" />
  <div class="body__title">
    {{ '+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_SUCCESS_TITLE' | translate }}
  </div>

  <ng-container
    *ngIf="assignmentValidationResult; then deviceAssignmentValidationResult"
  ></ng-container>
</ng-template>

<ng-template #error>
  <img class="body__icon" src="assets/img/mark_circle.svg" />
  <div class="body__title">
    {{ '+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_ERROR_TITLE' | translate }}
  </div>
  <div class="body__description">
    {{ '+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_ERROR_DESCRIPTION' | translate }}
  </div>

  <ng-container
    *ngIf="assignmentValidationResult; then deviceAssignmentValidationResult"
  ></ng-container>
</ng-template>

<ng-template #deviceAssignmentValidationResult>
  <form [formGroup]="devicesNamesForm">
    <div class="validation-result-wrapper">
      <div formArrayName="devicesNamesFormArray" class="form-array">
        <ng-container *ngFor="let entry of assignmentValidationResult; let i = index">
          <ng-container [ngSwitch]="entry.type">
            <ng-container *ngSwitchCase="DeviceAssignmentType.Room">
              <div
                class="validation-result-entry"
                [class.validation-result-entry-error]="!entry.isSuccess"
              >
                {{
                  gatewayStore.getDeviceRoles(entry['deviceId']) | async | translateDeviceByRoles
                }}
                {{
                  entry.isSuccess
                    ? ('+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_VALIDATION_ROOM_SUCCESS'
                      | translate: { device: entry['deviceId'], roomName: entry['roomName'] })
                    : ('+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_VALIDATION_ROOM_ERROR'
                      | translate: { device: entry['deviceId'], roomName: entry['roomName'] })
                }}
              </div>
              <ng-container *ngIf="entry.isSuccess && (deviceName$ | async | ready)">
                <div class="flex flex-row gap-[8px] validation-device-name-form">
                  <mat-form-field mat-input-height-small>
                    <input
                      class="action-input"
                      #input
                      matInput
                      [formControl]="devicesNamesFormArray.controls[i]"
                      placeholder="{{
                        '+SRC_COMMISSIONINGV2.ADD_DEVICE_NAME_DESCRIPTION' | translate
                      }}"
                      type="text"
                      maxlength="40"
                      gtm="onTextField"
                      gtmAction="Device name"
                      gtmCategory="editDeviceNameModal"
                      fieldTextContentTooltip
                    />
                    <mat-error *ngIf="devicesNamesFormArray.controls[i].hasError('notUnique')">
                      {{ '+EDIT_DEVICE_NAME_MODAL.NAME_NOT_UNIQUE' | translate }}
                    </mat-error>
                    <mat-error
                      *ngIf="devicesNamesFormArray.controls[i].hasError('specialCharacters')"
                    >
                      {{ '+EDIT_DEVICE_NAME_MODAL.ERROR_SPECIAL_CHARACTERS' | translate }}
                    </mat-error>
                  </mat-form-field>

                  <button
                    class="action-save"
                    gtm="onSaveDeviceName"
                    gtmAction="Save"
                    gtmCategory="finalResultsModal"
                    mat-stroked-button
                    color="primary"
                    (click)="saveDeviceName()"
                  >
                    {{ 'GENERAL.BUTTON.SAVE' | translate }}
                  </button>
                </div>
              </ng-container>
            </ng-container>

            <div
              class="validation-result-entry"
              [class.validation-result-entry-error]="!entry.isSuccess"
              *ngSwitchCase="DeviceAssignmentType.Hc"
            >
              {{ gatewayStore.getDeviceRoles(entry['deviceId']) | async | translateDeviceByRoles }}

              {{
                entry.isSuccess
                  ? ('+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_VALIDATION_HC_SUCCESS'
                    | translate: { hc: +entry['circuitId'] + 1 })
                  : ('+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_VALIDATION_HC_ERROR'
                    | translate: { hc: +entry['circuitId'] + 1 })
              }}
            </div>

            <div
              class="validation-result-entry"
              [class.validation-result-entry-error]="!entry.isSuccess"
              *ngSwitchCase="DeviceAssignmentType.Channel"
            >
              {{
                entry.isSuccess
                  ? ('+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_VALIDATION_CHANNEL_SUCCESS'
                    | translate
                      : { fhtChannel: entry['fhtChannelDeviceId'], roomName: entry['roomName'] })
                  : ('+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_VALIDATION_CHANNEL_ERROR'
                    | translate
                      : { fhtChannel: entry['fhtChannelDeviceId'], roomName: entry['roomName'] })
              }}
            </div>

            <div
              class="validation-result-entry"
              [class.validation-result-entry-error]="!entry.isSuccess"
              *ngSwitchCase="DeviceAssignmentType.RemoteHC"
            >
              {{ selectedDeviceName | translate }}
              {{
                entry.isSuccess
                  ? ('+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_VALIDATION_HC_SUCCESS'
                    | translate: { hc: +entry['circuitId'] })
                  : ('+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_VALIDATION_HC_ERROR'
                    | translate: { hc: +entry['circuitId'] })
              }}
            </div>
            <div
              class="validation-result-entry"
              [class.validation-result-entry-error]="!entry.isSuccess"
              *ngSwitchCase="DeviceAssignmentType.Ventilation"
            >
              {{ selectedDeviceName | translate }}
              {{
                entry.isSuccess
                  ? ('+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_VALIDATION_VENTILATION_SUCCESS'
                    | translate: { ventilation: +entry['ventilationId'] })
                  : ('+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_VALIDATION_VENTILATION_ERROR'
                    | translate: { ventilation: +entry['ventilationId'] })
              }}
            </div>
            <ng-container *ngIf="(pairedDeviceNameFeature$ | async) && entry.isSuccess">
              <div class="flex flex-row gap-[8px] validation-device-name-form">
                <mat-form-field mat-input-height-small>
                  <input
                    class="action-input"
                    #input
                    matInput
                    [formControl]="devicesNamesFormArray.controls[i]"
                    placeholder="{{
                      '+SRC_COMMISSIONINGV2.ADD_DEVICE_NAME_DESCRIPTION' | translate
                    }}"
                    type="text"
                    maxlength="40"
                    gtm="onTextField"
                    gtmAction="Device name"
                    gtmCategory="editDeviceNameModal"
                    fieldTextContentTooltip
                  />
                  <mat-error *ngIf="devicesNamesFormArray.controls[i].hasError('notUnique')">
                    {{ '+EDIT_DEVICE_NAME_MODAL.NAME_NOT_UNIQUE' | translate }}
                  </mat-error>
                  <mat-error
                    *ngIf="devicesNamesFormArray.controls[i].hasError('specialCharacters')"
                  >
                    {{ '+EDIT_DEVICE_NAME_MODAL.ERROR_SPECIAL_CHARACTERS' | translate }}
                  </mat-error>
                </mat-form-field>

                <button
                  class="action-save"
                  gtm="onSaveDeviceName"
                  gtmAction="Save"
                  gtmCategory="finalResultsModal"
                  mat-stroked-button
                  color="primary"
                  [disabled]="!devicesNamesFormArray.controls[i].valid"
                  (click)="saveFhtChannelName(entry['fhtChannelDeviceId'], entry['deviceId'], i)"
                >
                  {{ 'GENERAL.BUTTON.SAVE' | translate }}
                </button>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #buttonsSuccess>
  <mat-card-actions>
    <div class="body__actions">
      <button
        data-at-result-modal-close-btn
        mat-stroked-button
        gtm="onCancelDialog"
        gtmAction="Close"
        gtmCategory="finalResultsModal"
        color="primary"
        (click)="closeDialog()"
      >
        {{ '+SRC_COMMISSIONINGV2.CLOSE_WINDOW' | translate }}
      </button>
      <button
        data-at-result-modal-next-btn
        mat-raised-button
        gtm="onConfirm"
        gtmAction="Add another component"
        gtmCategory="finalResultsModal"
        color="primary"
        (click)="addAnotherComponent()"
      >
        {{ '+SRC_COMMISSIONINGV2.ADD_ANOTHER_COMPONENT' | translate }}
      </button>
    </div>
  </mat-card-actions>
</ng-template>

<ng-template #buttonsError>
  <mat-card-actions>
    <div class="body__actions">
      <button
        gtm="onCancelDialog"
        gtmAction="Close"
        gtmCategory="finalResultsModal"
        data-at-result-modal-close-btn
        mat-stroked-button
        color="primary"
        (click)="closeDialog()"
      >
        {{ '+SRC_COMMISSIONINGV2.CLOSE_WINDOW' | translate }}
      </button>
      <button
        gtm="onConfirm"
        gtmAction="Retry Device assignment"
        gtmCategory="finalResultsModal"
        data-at-result-modal-next-btn
        mat-raised-button
        color="primary"
        (click)="deviceAssignRetry()"
      >
        {{ '+SRC_COMMISSIONINGV2.DEVICE_ASSIGNMENT_RETRY' | translate }}
      </button>
    </div>
  </mat-card-actions>
</ng-template>
